export default __webpack_public_path__ + "static/windows-cc-5109a5715f6dd708be6631fc39be090e.mp4";